type ProfileState = {
  profile: {
    hasFetched: boolean;
    isFetching: boolean;
    SSOid?: string;
    data?: {
      avatar_id?: string;
      avatar_url?: string;
      email?: string;
      email_unsubscribes?: { all: boolean };
      email_verified?: boolean;
      ext_user_id?: string;
      first_name?: string;
      is_host?: boolean;
      is_instant_book_eligible_host?: boolean;
      is_vendor?: boolean;
      last_name?: string;
      host_heard_from?: string[];
      phone?: string;
      phone_confirmation_attempts_for_today?: number;
      phone_e164?: string;
      phone_country?: string;
      phone_country_code?: string;
      phone_formatted?: string;
      phone_verified?: boolean;
      organization?: string;
      preferred_locale?: string;
      username?: string;
    };
  };
};

const selectProfileIsFetching = (state: ProfileState) =>
  Boolean(state.profile.isFetching);
const selectProfileHasFetched = (state: ProfileState) =>
  Boolean(state.profile.hasFetched);
const selectProfileSSOid = (state: ProfileState) => state.profile.SSOid;
const selectFirstName = (state: ProfileState) =>
  state.profile?.data?.first_name;
const selectLastName = (state: ProfileState) => state.profile?.data?.last_name;
const selectExtUserId = (state: ProfileState) =>
  state.profile?.data?.ext_user_id;
const selectProfilePhoneE164 = (state: ProfileState) =>
  state.profile?.data?.phone_e164;
const selectProfilePhoneFormatted = (state: ProfileState) =>
  state.profile?.data?.phone_formatted;
const selectProfilePhoneVerified = (state: ProfileState) =>
  state.profile.data?.phone_verified;
const selectProfileAvatarUrl = (state: ProfileState) =>
  state.profile.data?.avatar_url;
const selectProfileHostHeardFrom = (state: ProfileState) =>
  state.profile.data?.host_heard_from;
const selectIsInstantBookEligibleHost = (state: ProfileState) =>
  Boolean(state.profile.data?.is_instant_book_eligible_host);
const selectProfileIsVendor = (state: ProfileState) =>
  Boolean(state.profile.data?.is_vendor);
const selectProfileIsHost = (state: ProfileState) =>
  Boolean(state.profile.data?.is_host);
const selectProfileOrganization = (state: ProfileState) =>
  state.profile.data?.organization ?? "";
const selectProfileData = (state: ProfileState) => state.profile.data;

export {
  selectIsInstantBookEligibleHost,
  selectProfileAvatarUrl,
  selectProfileHasFetched,
  selectExtUserId,
  selectFirstName,
  selectLastName,
  selectProfileData,
  selectProfileIsFetching,
  selectProfileIsHost,
  selectProfileIsVendor,
  selectProfileOrganization,
  selectProfileHostHeardFrom,
  selectProfilePhoneE164,
  selectProfilePhoneFormatted,
  selectProfilePhoneVerified,
  selectProfileSSOid,
};

export type { ProfileState };
